import { type Components, type Theme } from "@mui/material";

export const fidooToggleButtonGroup: Components<Theme>["MuiToggleButtonGroup"] =
  {
    defaultProps: {
      variant: "default",
    },
    styleOverrides: {
      root: () => ({
        padding: "4px",
        gap: "4px",
      }),
    },
    variants: [
      {
        props: { variant: "default" },
        style: ({ theme }) => ({
          borderRadius: "8px",
          backgroundColor: theme.palette.secondary.main,
          "& .MuiToggleButton-root:not(:last-of-type)": {
            borderTopRightRadius: "4px",
            borderBottomRightRadius: "4px",
          },
          "& .MuiToggleButton-root:not(:first-of-type)": {
            borderTopLeftRadius: "4px",
            borderBottomLeftRadius: "4px",
          },
        }),
      },
      {
        props: { variant: "secondary" },
        style: ({ theme }) => ({
          borderRadius: "9999px",
          backgroundColor: theme.palette.custom.fillSecondary,
          "& .MuiToggleButton-root": {
            color: theme.palette.text.primary,
            borderRadius: "9999px",
            paddingRight: theme.spacing(1.6),
            paddingLeft: theme.spacing(1.6),
          },
          "& .MuiToggleButton-root:not(.Mui-selected)": {
            color: theme.palette.text.primary,
            backgroundColor: theme.palette.custom.fillSecondary,
            "&:hover": {
              backgroundColor: theme.palette.custom.fillSecondaryHover,
            },
          },
          "& .MuiToggleButton-root.Mui-selected": {
            backgroundColor: "white",
            color: theme.palette.text.primary,
            "&:hover": {
              backgroundColor: theme.palette.custom.surfaceTertiary,
            },
          },
        }),
      },
      {
        props: { size: "small" },
        style: () => ({
          "& .MuiToggleButton-root svg": {
            width: "18px",
            height: "18px",
          },
        }),
      },
      {
        props: { size: "medium" },
        style: () => ({
          "& .MuiToggleButton-root svg": {
            width: "20px",
            height: "20px",
          },
        }),
      },
      {
        props: { size: "large" },
        style: () => ({
          "& .MuiToggleButton-root svg": {
            width: "24px",
            height: "24px",
          },
        }),
      },
    ],
  };
